<div id="content" class="page">
  <div class="page__header">
    <custom-app-bar [hasBackButton]="true"></custom-app-bar>
  </div>
  <div class="page__content">
    <h1 class="header2">{{ "delivery_points.title" | translate }}</h1>
    <p class="text">{{ "delivery_points.message" | translate }}</p>

    <ep-delivery-points
            [deliveryPoints]="deliveryPoints"
            [autoSave]="false"
            (deliveryPointChange)="onSelectedDeliveryPoint($event)"
    ></ep-delivery-points>
  </div>

  <div class="page__footer">
    <button customButton
            expand="full"
            size="large"
            (click)="onClickButton()"
    >
      {{ "delivery_points.start" | translate }}
    </button>
  </div>
</div>
